<div class="modal-header">
    <h3 class="modal-title">
        Renovar ByR
    </h3>
</div>
<div class="modal-body">
    <div class="row">

        <div class="col-md-6 mb-3">
            <label for="fechaInicio" class="col-form-label">Fecha y hora vigencia desde:</label>
            <div class="input-group">
                <input id="fechaInicio" type="date" [ngModel]="modelDesde"
                    class="fechaFormControlDesdeHasta form-control form-control-rounded" placeholder="aaaa-mm-dd"
                    (ngModelChange)="changeModelDesde($event)" name="dt" ngbDatepicker #d="ngbDatepicker" required
                    readonly />
                <div class="input-group-append">
                    <button id="botonDesde" type="button" class="btn btn-secondary" (click)="d.toggle()">
                        <i class="fa fa-calendar" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="col-md-6 mb-3">
            <label for="fechaFin" class="col-form-label">Fecha y hora vigencia hasta:</label>
            <div class="input-group">
                <input id="fechaFin" type="date" [ngModel]="modelHasta"
                    class="fechaFormControlDesdeHasta form-control form-control-rounded" placeholder="aaaa-mm-dd"
                    (ngModelChange)="changeModelHasta($event)" name="dp" ngbDatepicker #h="ngbDatepicker" required
                    readonly />
                <div class="input-group-append">
                    <button id="botonHasta" type="button" class="btn btn-secondary" (click)="h.toggle()">
                        <i class="fa fa-calendar" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6">
            <div class="input-group mb-2">
                  <ngb-timepicker [ngModel]="modelHoraInicioByR" (ngModelChange)="changeModelHoraDesde($event)" [meridian]="true"></ngb-timepicker>
            </div>
        </div>
        <div class="col-md-6">
            <div class="input-group mb-2">
                <ngb-timepicker [ngModel]="modelHoraFinByR" (ngModelChange)="changeModelHoraHasta($event)" [meridian]="true"></ngb-timepicker>
          </div>
        </div>
    </div>

    <div class="row mt-3">
        <label for="motivo" class="col-form-label">Motivo:</label>
        <div class="col-12">
            <textarea spellcheck="false" rows="5" maxlength="500" id="motivo" class="form-control" [(ngModel)]="motivo" placeholder="Motivo"></textarea>
        </div>
    </div>

    <div *ngIf="errorFecha" class="alert alert-danger mt-3" role="alert">
        {{ errorFecha }}
    </div>

    <div *ngIf="!motivo" class="alert alert-danger mt-3" role="alert">
        Debe ingresar un motivo.
    </div>
</div>

<div class="modal-footer">
    <button class="btn btn-primary" [disabled]="superponeFecha || !motivo || renovando" (click)="renovarByR()">
        @if(renovando) {<i class="fa fa-spinner fa-spin"></i> Renovando} @else {Renovar}
    </button>
    <button class="btn btn-secondary" (click)="cerrarModal()">
        Cancelar
    </button>
</div>